import http from '@util/http';
import { finance } from '@api/req';

export async function queryReceiptList(params) {
  return http.get(finance.GET_RECEIPT_LIST, params);
}

export async function queryReceiptInfo(params) {
  return http.get(finance.GET_RECEIPT_INFO, params);
}

export async function querySaveReceipt(params) {
  return http.post(finance.SAVE_RECEIPT, params);
}

export async function queryDeleteReceipt(params) {
  return http.get(finance.DELETE_RECEIPT, params);
}

export async function queryAbleReceipt(params) {
  return http.post(finance.ABLE_RECEIPT, params);
}

export async function queryImportReceipt(params) {
  return http.post(finance.IMPORT_RECEIPT, params);
}

export async function queryDownloadReceiptTemplate() {
  http.download(finance.DOWNLOAD_RECEIPT_TEMPLATE, {}, '公司回单卡记录-模板.xlsx');
}



// WEBPACK FOOTER //
// ./src/api/finance/receipt.js